// IR-626 — hook for the synthetic page-load monitoring samples.
// Backed by `evaluate_page_load_breach` and the
// `ops_page_load_samples` table on the iris-backend side.
import { api } from "@/lib/api";
import { useQuery } from "@tanstack/react-query";

export interface PageLoadSample {
  id: number;
  latency_ms: number;
  status_code: number;
  error_text: string | null;
  sampled_at: string;
}

export interface PageLoadGroup {
  env: "dev" | "prod";
  page: "/search" | "/dashboard";
  samples: PageLoadSample[];
}

interface PageLoadResponse {
  data: PageLoadGroup[];
}

// 60s poll matches the probe's 5-min cadence well — we don't gain much by
// polling faster than the probe's own write rate.
const POLL_60S = { refetchInterval: 60_000 };

export function usePageLoad(limit = 60) {
  return useQuery({
    queryKey: ["monitoring", "page-load", limit],
    queryFn: () => api<PageLoadResponse>(`/api/ops/v1/monitoring/page-load/?limit=${limit}`),
    ...POLL_60S,
  });
}
